import styled from 'styled-components'

import { Icon } from 'Components/UI'

import arrowLeftLongGlyph from 'Assets/_Legacy/Svg/arrow-left-long.svg'

export const ButtonIcon = styled(Icon).attrs({
  glyph: arrowLeftLongGlyph,
  size: 15,
})`
  margin-left: 10px;
  transform: rotateZ(180deg);
`

export default ButtonIcon
